import type { components } from '@/api/generated/schema'

type Kpi = components['schemas']['Kpi']

/**
 * `div.kpis` → `kpi-row` / `div.kpi` → `kpi` (process/08-COMPONENT-CATALOGUE.md). One report's
 * headline figures (`Report.kpis`, §28.2) — each a server-computed, server-labelled sub-count
 * (`div.n` → `stat-figure`, `div.l` → `stat-label`); this component never derives a figure or a
 * label itself. `.kpi`/`.kpis` carry no CSS rule in the prototype (HISTORY.md W41), so the
 * tile styling here is this component's own, not a transcription.
 */
export function Kpis({ items }: { items: readonly Kpi[] }) {
  if (items.length === 0) return null
  return (
    <div data-cmp="kpi-row" className="flex flex-wrap gap-4">
      {items.map((kpi, i) => (
        <div key={i} data-cmp="kpi" className="border border-bd rounded-2 py-4 px-5" style={{ minWidth: 160 }}>
          <div data-cmp="stat-figure" className="text-section font-semibold">
            {kpi.value.display}
          </div>
          <div data-cmp="stat-label" className="text-small text-tx2 mt-1">
            {kpi.label}
          </div>
        </div>
      ))}
    </div>
  )
}
